<div class="predisclaimer-page-container flex justify-center">
  <div class="predisclaimer-page-content-wrapper pb-6 w-[80vw]">
    <form (ngSubmit)="validatePreDisclaimer()" accept-charset="utf-8">
      <div class="predisclaimer-page-description mb-4 text-sm disclaimer-section">
        <br />
        Access to and use of the BNP Paribas INDX website (the "Site") is
        subject to the
        <a [routerLink]="termsOfUsePath" class="text-blue-600 underline">Terms of use</a>, and by
        accessing the Site you are deemed to have accepted these Terms
        of Use. Access to some or all parts of the Site may be restricted to
        persons to whom login credentials have been issued.
        <br />

        <br />
        By accessing the site, you are deemed to have accepted the Terms of Use.
        If you do not accept the Terms of Use, please refrain from using the
        Site. This Site has been developed for discussion purposes only and does
        not constitute an offer or solicitation to engage in any trading
        strategy or the purchase or sale of any financial instruments.
        <br />
        <br />
        US vs Non US
        <br /><br />
        I expressly acknowledge and confirm that I am not a
        <a href="{{ deployUrlHost }}/assets/pdf/Reg_S_US_Person_Definition.pdf" class="text-blue-600 underline"
          target="_blank">U.S. Person</a>
        (as defined in Regulation S of the U.S. Securities Act of 1933, as
        amended), nor am I acting for the account or benefit of a U.S. Person.
        <br />
        <br />
        OR
        <br />
        <br />
        I expressly acknowledge and confirm that I am a
        <a href="{{ deployUrlHost }}/assets/pdf/Reg_S_US_Person_Definition.pdf" class="text-blue-600 underline"
          target="_blank">U.S. Person</a>
        (as defined in Regulation S of the U.S. Securities Act of 1933, as
        amended), or I am acting for the account or benefit of a U.S. Person.
      </div>

      <div>
        <input id="USResident" type="radio" class="radio" value="US" [(ngModel)]="selectedResident"
          (change)="USnonUsSelection()" name="resident" /><label for="USResident" class="ml-2">US Person</label>
      </div>
      <div class="input-margin">
        <input id="NonUSResident" type="radio" class="radio" [(ngModel)]="selectedResident" value="NONUS"
          name="resident" (change)="USnonUsSelection()" /><label for="NonUSResident" class="ml-2">Non US Person</label>
      </div>

      <br />
      <div class="check-input-margin col-xs-12 no-padding">
        <input type="checkbox" class="predisclaimercheck" id="checkbox_1" [(ngModel)]="isAgreeChecked"
          name="agree" /><label for="checkbox_1"></label>
        <label class="predisclaimer-label disclaimer-condition" for="checkbox_1">
          I agree to the conditions above, I accept the Terms of Use and I wish
          to proceed.*</label>
      </div>
      <div class="mandatory">
        <p>*Mandatory field</p>
      </div>
      <div class="flex justify-end mt-4">
        <button [ngClass]="{
            'bg-black hover:bg-gray-800': isFormValid(),
            'bg-gray-400 cursor-not-allowed': !isFormValid()
          }" class="text-white px-4 py-2 rounded" type="submit" role="button" [disabled]="!isFormValid()">
          Accept
        </button>
      </div>

      <div class="copyright">© BNP Paribas 2017. All rights reserved</div>
    </form>
  </div>
</div>